<template>
  <div class="LC_procedure" ref="LC_procedure">
    <div class="viewBox">
      <ul class="procedure-box">
        <li class="procedure-row" v-for="(item , i) in dataList" :idx="i" :key="i" @click="rowClick(i)">
          <div class="procedure-name">{{item.process}}</div>
          <div class="procedure-status-box">
            <div class="leftBox">
              <div class="box1">同比</div>
              <div class="box2" :class="{up:upOrDown(item.percentage,'up'),down:upOrDown(item.percentage,'down')}">{{item.percentage}}%</div>
              <div class="box2i" :class="{box2iup:upOrDown(item.percentage,'up'),box2idown:upOrDown(item.percentage,'down')}"></div>
            </div>
            <div class="rightBox">
              <div class="box3 number" :style="{color:getColor(i)}">{{item.total}}</div>
              <div class="unit">吨</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import carbonEmission from '@/modules/lowcarbonComponents/carbonDischargeInfo/carbonEmissionProcess';
import { mapGetters } from 'vuex';
export default {
  components: {
    carbonEmission,
  },
  props: ['matrix', 'x', 'y'],
  data() {
    //这里存放数据
    return {
      pageInfo: 'LC_procedure.vue',
      customerId: this.$store.state.customerId,
      dataList: [],
      setTime1: null,
    };
  },
  //计算属性 类似于data概念
  computed: {
    getColor() {
      return (i) => {
        let colorVal;
        if (i == 0) {
          colorVal = '#ff7373';
        } else if (i == 1) {
          colorVal = '#f4c48f';
        } else if (i == 2) {
          colorVal = '#ffff89';
        } else {
          colorVal = '#99f5ff';
        }
        return colorVal;
      };
    },
    upOrDown() {
      return (val, type) => {
        if (type == 'down') {
          if (val < 0) {
            return true;
          }
        } else if (type == 'up') {
          if (val >= 0) {
            return true;
          }
        }
      };
    },
    ...mapGetters({
      dialogCompontent: 'getDialogCompontent',
    }),
  },
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.LC_procedure).outerWidth();
    let h = $(that.$refs.LC_procedure).outerHeight();
    that.$emit('componentInit', {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getListData();
  },
  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1);
      this.setTime1 = null;
    }
  },
  //方法集合
  methods: {
    rowClick(i) {
      this.$store.commit('dialogStatus', true);
      this.$popup.open(carbonEmission, this.dialogCompontent);
    },
    autoMove() {
      let that = this;
      $('.viewBox .procedure-box').each(function () {
        const dom = $(this).children();
        // $(this).empty();
        var rows = dom.clone(true);
        rows.addClass('copy');
        $(this).append(rows);
        for (let i = 0; i < rows.length; i++) {
          let tmpRow = $(rows.get(i));
          tmpRow.unbind('click');
          tmpRow.bind('click', function () {
            that.rowClick($(this).attr('idx'));
          });
        }
      });
    },
    async getListData() {
      let that = this;
      if (this.setTime1) {
        clearTimeout(this.setTime1);
        this.setTime1 = null;
      }
      try {
        const getProcedureTypeData =
          CONFIG.requestName + this.$apiOpt.getProcedureTypeData;
        let res = await this.$apiUtils.get(getProcedureTypeData, {
          customerId: this.customerId,
        });
        console.log('6666', this);
        $('.procedure-box').removeClass('animate');
        this.dataList = [];
        $('.copy').remove();
        this.$forceUpdate();
        this.$nextTick(() => {
          this.dataList = res || [];
          this.$forceUpdate();
          if (res && res.length >= 8) {
            that.$nextTick(() => {
              that.autoMove();
              $('.procedure-box').addClass('animate');
            });
          }
        });
        //$(".viewBox .procedure-box").empty();
      } catch (err) {
        console.log(err);
      }
      this.setTime1 = setTimeout(() => {
        this.getListData();
      }, 1000 * 3);
    },
  },
};
</script>
<style lang="scss" scoped>
.LC_procedure {
  height: 540px;
  width: 600px;
  pointer-events: all;
  padding-top: 62px !important;
  .viewBox {
    height: 100%;
    width: 100%;
    overflow: hidden;
    @keyframes move {
      0% {
      }
      100% {
        transform: translateY(-50%);
      }
    }
    .procedure-box {
      .procedure-row {
        width: 560px;
        height: 67px;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(img/commonRow.png);
        background-size: 300% 100%;
        margin-bottom: 20px;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 10px;

        &:hover {
          @extend .active;
        }
        .procedure-name {
          font-size: 18px;
          color: #99c0ff;
          line-height: 67px;
          text-overflow: ellipsis;
          width: 28%;
          overflow: hidden;
          white-space: nowrap;
          word-break: break-all;
        }
        .procedure-status-box {
          display: flex;
          width: 72%;
          justify-content: space-between;
          height: 100%;
          padding-bottom: 10px;
          padding-left: 10px;
          .leftBox {
            display: flex;
            align-items: flex-end;
            .box1 {
              font-size: 18px;
              color: #a0aaab;
              line-height: 18px;
              margin-right: 5px;
            }
            .box2 {
              font-size: 18px;
              color: #ec2323;
              line-height: 13px;
            }
            .box2i {
              margin-left: 2px;
              margin-bottom: -1px;
            }
            .box2iup {
              @include bg-box(12px, 20px, 'upicon.png');
            }
            .box2idown {
              @include bg-box(12px, 20px, 'downicon.png');
            }
            .up {
              color: #ec2323;
            }
            .down {
              color: #7ff4b1;
            }
          }
          .rightBox {
            display: flex;
            align-items: flex-end;
            .box3 {
              font-size: 32px;
              color: #99f5ff;
              line-height: 38px;
            }
            .unit {
              width: 36px;
              height: 18px;
              font-size: 18px;
              color: #a0aaab;
              line-height: 18px;
              margin-left: 5px;
            }
          }
        }
      }
      .active {
        background-image: url(img/activeRow.png);
        background-size: 300% 100%;
      }
    }
    .animate {
      animation: move 30s linear infinite;
      &:hover {
        animation-play-state: paused;
      }
    }
  }
}
</style>
